export default "__VITE_ASSET__C1n1Y2HJ__"